// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__1j7IT","label":"style_label__sAum8"};